import { partHasBehaviour, partHasSimModel } from "@buildwithflux/models";
import { getBehaviourWithoutComments } from "@buildwithflux/shared";
export function getPartSimulationData(partVersionData) {
    return {
        hasSimulationModel: partHasSimModel(partVersionData),
        hasBehaviour: partHasBehaviour(partVersionData),
        behaviour: partVersionData.behaviour ? getBehaviourWithoutComments(partVersionData.behaviour) : undefined,
        behaviourHasErrors: !!partVersionData.behaviour_has_errors,
    };
}
//# sourceMappingURL=simulation.js.map